module.exports = __webpack_public_path__ + "static/media/bus.8d71c177.svg";